import PropTypes from 'prop-types';

const InspectionFieldTemplate = props => {
  const {
    children,
  } = props;
  return (
    children
  );
};

InspectionFieldTemplate.propTypes = {
  children: PropTypes.element,
};

export default InspectionFieldTemplate;


// WEBPACK FOOTER //
// ./src/modules/common/components/form/templates/InspectionFieldTemplate.js